<template>
  <div
    v-if="announcement"
    :class="{
      'hekate-announcement': true,
    }"
  >
    <PtcIcon :name="'ptc-info'" />
    <div class="announcement-msg">
      <p class="announcement-timestamp">{{ prettyDateTime }}</p>
      <p class="announcement-msg-body">
        {{ message }}
        <a
          :href="announcement.learnMoreLink"
          target="_blank"
          rel="noopener noreferrer"
          :class="{
            'announcement-learn-more': true,
          }"
        >
          Learn More
        </a>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';
import type { QueryHekateAnnouncementResult } from '~/sanity/types';
import SolrFq from '~/utils/solr/SolrFq';
import SolrQuery from '~/utils/solr/SolrQuery';

const fq = SolrFq.and().push('_type_s', 'hekateAnnouncement').push('_isActive_b', 'true');
const q = SolrQuery.devObj().setFq(fq).setRange({ start: 0, rows: 1 });
const { data } = await useSolrQuery<QueryHekateAnnouncementResult>({
  q,
});

const announcement = data.value[0];
let letTimeString;

if (announcement?._updatedAt) {
  letTimeString = announcement._updatedAt;
} else {
  letTimeString = new Date().toISOString();
}
const dateCreated = new Date(letTimeString);
const prettyDateTime = dateCreated.toLocaleString([], { timeZoneName: 'short' });

const message = computed(() => {
  const lang = useSiteLang().lang.value;
  if (!announcement || !announcement.message) return '';

  if (lang !== 'en') {
    const currLangMsgKey = Object.keys(announcement).find((key) => {
      return key === `${lang}Message`;
    });

    if (currLangMsgKey) {
      return announcement[currLangMsgKey as keyof typeof announcement] || announcement.message;
    }
  }
  return announcement.message;
});
</script>

<style scoped>
.hekate-announcement {
  display: flex;
  flex-flow: row;
  justify-content: left;
  align-items: center;
  background-color: #fcb53b26; /*info-yellow*/
  border-radius: 5px;
  padding: 20px 15px;
  font-size: 14px;
  margin-bottom: 15px;
}

.announcement-msg {
  display: flex;
  justify-content: center;
  flex-flow: column;
  margin-left: 10px;
}

.announcement-msg .announcement-timestamp {
  font-weight: bold;
  margin: 0;
  font-size: 0.95rem !important;
}

.announcement-learn-more {
  color: #14629a; /*info-blue*/
  text-decoration: underline;
  font-weight: bold;
  margin-left: 10px;
}

.announcement-learn-more::after {
  background-image: url('data:image/svg+xml;utf8,<svg%20width="15"%20height="10"%20viewBox="0%200%2015%2010"%20fill="none"%20xmlns="http://www.w3.org/2000/svg"><path%20d="M10.5%200.5L9.70687%201.29312L12.8456%204.4375H0V5.5625H12.8456L9.70687%208.70687L10.5%209.5L15%205L10.5%200.5Z"%20fill="%2314629A"/></svg>');
  content: '';
  display: inline-block;
  margin-left: 2px;
  height: 9px;
  transition: background-image 0.3s ease-out;
  width: 15px;
}
</style>
